<dialog-header [dialogRef]="dialogRef" headerKey="PROMPT.UNSAVED_HEADER"></dialog-header>
<div mat-dialog-content>
  <p>{{ 'PROMPT.UNSAVED_CONTENT' | translate }}</p>
  <buttons-wrapper>
    <button mat-flat-button [mat-dialog-close]="'discard'">{{ 'DISCARD_CHANGES' | translate }}</button>
    <button mat-flat-button color="primary" [mat-dialog-close]="'save'">{{ 'SAVE' | translate }}</button>
  </buttons-wrapper>
</div>
